import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { TrialIndicator, TrialTone } from "@/lib/trial";

// Light-theme shades keep at least 3:1 contrast on white (WCAG 1.4.11); the
// dark theme keeps the brighter shades.
function toneClass(tone: TrialTone): string {
  switch (tone) {
    case "green":
      return "bg-green-600 dark:bg-green-500";
    case "yellow":
      return "bg-amber-600 dark:bg-yellow-400";
    case "red":
      return "bg-red-600 dark:bg-red-500";
    case "grey":
      return "bg-gray-500 dark:bg-gray-400";
  }
}

interface TrialStatusDotProps {
  indicator: TrialIndicator;
}

export function TrialStatusDot({ indicator }: TrialStatusDotProps) {
  const { tone, label, period } = indicator;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          role="img"
          aria-label={`Trial: ${label}`}
          data-tone={tone}
          className={`inline-block h-2.5 w-2.5 rounded-full ${toneClass(tone)}`}
        />
      </TooltipTrigger>
      <TooltipContent>
        <p className="text-xs font-medium">{label}</p>
        {period && <p className="text-xs">{period}</p>}
      </TooltipContent>
    </Tooltip>
  );
}
